import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
} from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import useDeviceDetect from '../../hooks/useDeviceDetect';
import clsx from 'clsx';
import { blueBar } from '../../helpers/common';
import AddIcon from '@material-ui/icons/Add';
import DatasetFilter from './DatasetFilter';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import UserContext from '../../context/UserContext';
import { FILTER_INITIAL_VALUES, initialGroup } from './helpers';
import { NavLink } from 'react-router-dom';
import DatePickerCommon from '../DatePicker/DatePickerCommon';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getStatusNodes } from '../../services/meters';

// Función para crear copia profunda que maneja fechas correctamente
const deepCloneWithDates = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;
  
  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }
  
  if (Array.isArray(obj)) {
    return obj.map(item => deepCloneWithDates(item));
  }
  
  const cloned = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      cloned[key] = deepCloneWithDates(obj[key]);
    }
  }
  return cloned;
};

let scrollsSettings = {
  overflow: 'scroll',
  overflowX: 'hidden',
};
let webkitScrollbar = {
  background: 'white',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#beb1b18f',
  color: 'red',
  width: '9px',
};
let webkitscrollbarTrack = {
  background: '#dfdfe957',
};

const useStyles = makeStyles(theme => ({
  root: {
    ...scrollsSettings,
    '&::-webkit-scrollbar': {
      //son los estilos de las barras scroll en una variable.
      ...webkitScrollbar,
    },
    '&::-webkit-scrollbar-track': {
      //son los estilos de las barras scroll en una variable.
      ...webkitscrollbarTrack,
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.main,
    },
  },
  label: {
    marginLeft: theme.spacing(3),
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.primary.main,
    '@media (max-width: 700px)': {
      marginLeft: theme.spacing(1),
      marginBottom: '5px',
    },
  },
  btn: {
    margin: theme.spacing(3, 1),
  },
  leftSpacing: {
    marginLeft: theme.spacing(1),
  },
  hint: {
    backgroundColor: 'rgba(0, 0, 0, 0.38)',
    color: theme.palette.common.white,
    height: theme.spacing(3),
    width: theme.spacing(3),
    minWidth: '25px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'rgb(54, 143, 193);',
    },
  },
  tick: {
    backgroundColor: theme.palette.success.light,
  },
  active: {
    backgroundColor: theme.palette.primary.main,
  },
  titleGroup: {
    color: theme.palette.primary.main,
    fontSize: '16px',
    padding: '8px'
  },
  devicesLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
  },
  addBtn: {
    margin: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    height: theme.spacing(3),
    width: theme.spacing(3),
    '&:hover': {
      backgroundColor: 'rgb(54, 143, 193);',
    },
  },
  chip: {
    margin: theme.spacing(0.5),
    '@media (max-width: 700px)': {
      width: '200px',
    },
  },
  secondaryContainer: {
    border: `1px dashed ${theme.palette.secondary.light}`,
    borderRadius: '20px',
    width: '100%',
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    minHeight: '34%',
  },
  primaryContainer: {
    minHeight: '34%',
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
    border: '1px solid #00000029',
    borderRadius: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  help: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    padding: theme.spacing(0.5),
  },
  labelHowWorks: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  wrapperDatepicker: {
    position: 'relative',
    width: '100%',
    left: '50%',
    transform: 'translate(-50%)',
    textAlign: 'center',
    marginTop: '20px',
  },
}));

export default function Filter({ filterOptions, setFilterPanel, onSubmit }) {
  const classes = useStyles();
  const blueLine = blueBar();
  const [activeStep, setActiveStep] = useState(0);
  const { isMobile } = useDeviceDetect(990);
  const { plan } = useContext(UserContext);
  const steps = [
    'Elija la granularidad',
    'Complete el grupo primario',
    'Complete el grupo secundario (Opcional)',
    'Complete el grupo terciario (Opcional)',
  ];
  const [showDatasetFilter, setShowDatasetFilter] = useState(false);
  const [datasetSelected, setDatasetSelected] = useState(null);
  const [indexGroupselected, setIndexGroupselected] = useState(null);
  const [indexDataSetSelected, setIndexDataSetSelected] = useState(null);
  const [mainObj, setMainObj] = useState(filterOptions);
  const enabledItems = plan?.sections['HISTORICOS'].filter(
    item => item.enabled
  );

  const objectCatalog = {};
  const [filterCalendarConfig, setFilterCalendarConfig] = useState({
    views: ['month', 'year'],
    disabled: false,
    format: 'MM/yyyy',
  });
  const [showCleanAllDialog, setShowCleanAllDialog] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [calendars, setCalendars] = useState(
    FILTER_INITIAL_VALUES.groups.map(() => ({ open: false }))
  );
  const periods = [
    {
      label: 'Diaria',
      key: 'DAILY',
    },
    {
      label: 'Mensual',
      key: 'MONTHLY',
    },
    {
      label: 'Anual',
      key: 'YEARLY',
    },
  ];
  const [date, setDate] = useState(null)

  const [dateRange, setDateRange] = useState({
    dateStart: filterOptions?.groups?.[0]?.dateStart || null,
    dateEnd: filterOptions?.groups?.[0]?.dateEnd || null,
  });

  const [statusNodes, setStatusNodes] = useState([]);
  
  useEffect(() => {
    const getStatusNodesAux = async () => {
      let res = await getStatusNodes()
      let arry = res.data
      setStatusNodes(arry)
    }
    getStatusNodesAux()
  }, [])

  useEffect(() => {
    setDateRange({
      dateStart: filterOptions?.groups?.[0]?.dateStart || null,
      dateEnd: filterOptions?.groups?.[0]?.dateEnd || null,
    });
  }, [filterOptions]);

  const filterConfigCalendar = () => {
    const config = {};
    switch (mainObj.granularity) {
      case 'DAILY':
        config.views = ['month', 'year'];
        config.disabled = false;
        config.format = 'MM/yyyy';
        //setSelectedDate(new Date());
        break;
      case 'MONTHLY':
        config.views = ['year'];
        config.disabled = false;
        config.format = 'yyyy';
        //setSelectedDate(new Date());
        break;
      case 'YEARLY':
        config.disabled = true;
        config.format = 'yy';
        //Como voy a mostrar todos los anuales muestro la fecha de hoy
        //setSelectedDate(new Date());
        break;
      default:
        return;
    }
    setFilterCalendarConfig(config);
  };

  enabledItems.forEach(item => {
    objectCatalog[item.key] = {
      key: item.key,
      name: item.tag ? item.tag : item.name,
      fields: item.fields,
      periods: item.periods,
      phase: item.phase,
    };
  });

  useEffect(() => {
    calculateActiveStep();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Actualizo el tipo de calendario de acuerdo a la granularidad recibida.
    filterConfigCalendar(mainObj);
    // eslint-disable-next-line
  }, [mainObj]);

  const handleFilterChange = e => {
    if (e.target.name === 'variable') {
      let granularity = enabledItems?.find(item => item.key === e.target.value);
      let period = granularity.periods[0]?.key;
      //Si elije la otra variable y la granularidad q tenia coincide con una opcion valida la sigo mostrando.
      let findSameGranularity = granularity?.periods.find(
        item => item.key === mainObj?.granularity
      );
      setMainObj({
        ...mainObj,
        variable: e.target.value,
        granularity: findSameGranularity ? findSameGranularity.key : period,
        showPhase: objectCatalog[e.target.value]?.phase,
      });
      if (!mainObj.variable) {
        setActiveStep(2);
      }
    }
    if (e.target.name === 'granularity') {
      setMainObj({
        ...mainObj,
        granularity: e.target.value,
      });
      if (!mainObj.granularity) {
        setActiveStep(2);
      }
      filterConfigCalendar({
        ...mainObj,
        granularity: e.target.value,
      });
    }
  };

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(mainObj);
      setFilterPanel(false);
    }
  };

  const handleOpenDatasetModal = (indexGroup, e) => {
    //si hay evento de click
    if (e) {
      // Crear una copia profunda del mainObj para evitar mutaciones
      let newMainObj = deepCloneWithDates(mainObj);
      let newMainObjDatasets = newMainObj.groups[indexGroup].datasets;
      newMainObjDatasets.push({});
      setMainObj(newMainObj);
      setDatasetSelected(newMainObjDatasets[newMainObjDatasets.length - 1]);
      setIndexGroupselected(indexGroup);
      setIndexDataSetSelected(newMainObjDatasets.length - 1);
      setShowDatasetFilter(true);
    }
  };

  const deleteGroup = (index) => {
    // Crear una copia profunda del mainObj para evitar mutaciones
    const updatedMainObj = deepCloneWithDates(mainObj);
    updatedMainObj.groups.splice(index, 1);
    setMainObj(updatedMainObj);
  };

  const handleDeleteDataset = (indexGroup, indexDataset) => {
    // Crear una copia profunda del mainObj para evitar mutaciones
    const updatedMainObj = deepCloneWithDates(mainObj);
    updatedMainObj.groups[indexGroup].datasets.splice(indexDataset, 1);
    setMainObj(updatedMainObj);
    let datasetsGroup1 = updatedMainObj.groups[0]?.datasets;
    let datasetsGroup2 = updatedMainObj.groups[1]?.datasets;
    if (datasetsGroup1?.length === 0) {
      setActiveStep(2);
    } else if (datasetsGroup2?.length === 0) {
      setActiveStep(3);
    }
  };

  const handleCloseDatasetFilter = () => {
    setShowDatasetFilter(false);
  };

  const thereAreDatasetsInGroup = indexGroup => {
    return mainObj.groups[indexGroup]?.datasets?.some(dataset => dataset.alias);
  };

  const addGroup = () => {
    // Crear una copia profunda del mainObj para evitar mutaciones
    const auxMainObj = deepCloneWithDates(mainObj);
    // Copiar fechas del grupo principal
    const { dateStart, dateEnd } = auxMainObj.groups[0] || {};
    auxMainObj.groups.push({
      ...initialGroup,
      dateStart,
      dateEnd,
    });
    setMainObj(auxMainObj);
  };

  const toggleCalendar = (index, isOpen) => {
    setCalendars(prev =>
      prev.map((item, i) => (i === index ? { open: isOpen } : item))
    );
  };

  // Eliminar la función calendar y su uso en los grupos

  const addDataSetButton = (indexGroup, step) => {
    return (
      <Box
        display="flex"
        alignItems="center"
        flexWrap="wrap"
        minHeight={40}
      >
        <Tooltip
          title="Agrega un dataset haciendo click en el botón +"
          arrow
          placement="right"
        >
          <Box
            className={clsx(
              classes.hint,
              classes.leftSpacing,
              {
                [classes.active]: activeStep === step,
              },
              {
                [classes.tick]:
                  activeStep > step || thereAreDatasetsInGroup(indexGroup),
              }
            )}
          >
            {step}
          </Box>
        </Tooltip>
        <Box className={classes.devicesLabel}>
          Agregar dataset
        </Box>
        <IconButton
          aria-label="agregar dataset"
          className={classes.addBtn}
          onClick={e => handleOpenDatasetModal(indexGroup, e)}
        >
          <AddIcon fontSize="small" />
        </IconButton>
        <Box ml={1}>
          {mainObj?.groups[indexGroup]?.datasets?.map(
            (dataset, indx) =>
              dataset?.alias && (
                <Chip
                  className={classes.chip}
                  key={indx}
                  icon={<LabelImportantIcon style={{ fontSize: '18px' }} />}
                  label={dataset.alias}
                  clickable
                  color="primary"
                  onClick={() => {
                    setDatasetSelected(dataset);
                    setIndexDataSetSelected(indx);
                    setIndexGroupselected(indexGroup);
                    setShowDatasetFilter(true);
                  }}
                  onDelete={() => handleDeleteDataset(indexGroup, indx)}
                ></Chip>
              )
          )}
        </Box>
      </Box>
    )
  }

  const handleDateChange = (dateStart, dateEnd) => {
    setDateRange({ dateStart, dateEnd });
    const updatedMainObj = deepCloneWithDates(mainObj);
    updatedMainObj.groups = updatedMainObj.groups.map(group => ({
      ...group,
      dateStart,
      dateEnd,
    }));
    setMainObj(updatedMainObj);
  }

  const handleCopyConfig = indexGroup => {
    // Crear una copia profunda del mainObj para evitar mutaciones
    const updatedMainObj = deepCloneWithDates(mainObj);
    updatedMainObj.groups[indexGroup].datasets = [...mainObj.groups[0].datasets];
    updatedMainObj.groups[indexGroup].dateStart = mainObj.groups[0].dateStart;
    updatedMainObj.groups[indexGroup].dateEnd = mainObj.groups[0].dateEnd;
    setMainObj(updatedMainObj);
  };

  function calculateActiveStep() {
    if (thereAreDatasetsInGroup(2)) {
      setActiveStep(5);
    } else if (thereAreDatasetsInGroup(1)) {
      setActiveStep(4);
    } else if (thereAreDatasetsInGroup(0)) {
      setActiveStep(3);
    } else if (mainObj.granularity) {
      setActiveStep(2);
    }
  }

  const handleCleanFilter = () => {
    // Crea una copia profunda del filtro inicial para evitar mutaciones
    let filter = deepCloneWithDates(FILTER_INITIAL_VALUES);
    filter.groups = filter.groups.map(group => ({
      ...group,
      datasets: [],
      dateStart: null,
      dateEnd: null,
    }));
    setMainObj(filter);
    setActiveStep(0);
    setShowCleanAllDialog(false);
    setDateRange({
      dateStart: FILTER_INITIAL_VALUES.groups[0].dateStart,
      dateEnd: FILTER_INITIAL_VALUES.groups[0].dateEnd,
    }); // Limpiar fechas principales y poner valores por defecto
  };

  const getLabelGroup = (indexGroup) => {
    switch (indexGroup) {
      case 0:
        return 'Principal'
      case 1:
        return 'Secundario'
      case 2:
        return 'Terciario'
      default:
        return '';
    }
  }

  return (
    <>
      <Box p={6} className={classes.root}>
        <Stepper
          className={classes.steppersFilter}
          activeStep={activeStep}
          alternativeLabel
        >
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{isMobile ? '' : label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {blueLine}

        <p>
          Bienvenido a históricos avanzados, en esta sección usted podrá
          construir gráficos de barras versátiles que se adapten al análisis que
          desee realizar (ejemplo: comparación de consumo de energía entre
          diferentes períodos, filtrar consumos por franja horaria, comparar
          energía entre diferentes localizaciones, etc.).
          <b
            className={classes.labelHowWorks}
            onClick={() => setShowPreview(true)}
          >
            {' '}
            <br /> Click aquí para ver como funciona
          </b>
        </p>
        <p>
          NOTA: Si esta herramienta le resulta compleja o difícil de utilizar,
          le sugerimos primero probar con la sección{' '}
          <NavLink to="/historicos">Históricos</NavLink>.
        </p>

        <Grid container>
          {/* Granularidad */}
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Tooltip
                title="Elija la granularidad deseada"
                arrow
                placement="right"
              >
                <Box
                  className={clsx(classes.hint, classes.leftSpacing, {
                    [classes.tick]: mainObj?.granularity,
                  })}
                >
                  1
                </Box>
              </Tooltip>
              <FormControl fullWidth>
                <InputLabel id="granularityLabel">Granularidad</InputLabel>
                <Select
                  style={{ width: '90%' }}
                  labelId="granularityLabel"
                  name="granularity"
                  value={mainObj.granularity}
                  onChange={handleFilterChange}
                >
                  {periods.map(option => (
                    <MenuItem key={option.key} value={option.key}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {!mainObj.granularity && (
              <Box mt={1} className={classes.help}>
                Debe elegir una granularidad.
              </Box>
            )}
          </Grid>

          {/* NUEVO SELECTOR DE FECHAS PRINCIPAL */}
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" mt={2}>
              <Tooltip
                title="Seleccione el rango de fechas deseado"
                arrow
                placement="right"
              >
                <Box
                  className={clsx(classes.hint, classes.leftSpacing, {
                    [classes.active]: activeStep === 2,
                    [classes.tick]: activeStep > 2 || (dateRange.dateStart && dateRange.dateEnd),
                  })}
                >
                  2
                </Box>
              </Tooltip>
              <Box className={classes.devicesLabel} ml={1}>Seleccione fecha</Box>
              {mainObj.granularity !== 'YEARLY' ? (
                <DatePickerCommon
                  startDate={dateRange.dateStart}
                  endDate={dateRange.dateEnd}
                  setDate={setDate}
                  handleDateChange={(dateStart, dateEnd) => handleDateChange(dateStart, dateEnd)}
                  monthlyRangeView={mainObj.granularity === 'MONTHLY'}
                />
              ) : (
                <Box ml={2} display="flex" alignItems="center">
                  <p>Acumulado Histórico</p>
                </Box>
              )}
            </Box>
          </Grid>

          {/* GRUPOS */}
          {mainObj.groups.map((group, indexGroup) => (
            <Grid item xs={12} className={classes.primaryContainer}>
              <Box display="flex" alignItems="center" justifyContent={"space-between"}>
                <Box display="flex" alignItems="center">
                  <Box className={classes.titleGroup}>
                    Grupo {getLabelGroup(indexGroup)}
                  </Box>
                  {indexGroup !== 0 &&
                    <Tooltip title="Copiar configuración del grupo principal">
                      <Button onClick={() => handleCopyConfig(indexGroup)}>
                        <ContentCopyIcon style={{ fontSize: '18px' }} />
                      </Button>
                    </Tooltip>
                  }
                </Box>

                {indexGroup !== 0 &&
                  <Box>
                    <IconButton
                      className={classes.deleteIcon}
                      onClick={() => deleteGroup(indexGroup)}
                    >
                      <DeleteForeverIcon />
                    </IconButton>
                  </Box>
                }
              </Box>

              {addDataSetButton(indexGroup, 1)}
              {/* ELIMINADO EL CALENDARIO INDIVIDUAL DE CADA GRUPO */}

              {!thereAreDatasetsInGroup(indexGroup) && (
                <Box mt={1} className={classes.help}>
                  Debe agregar al menos un dataset.
                </Box>
              )}
            </Grid>
          ))
          }

          {/* BOTON AGREGAR GRUPO */}
          {mainObj.groups.length < 3 && (
            <Box
              mt={2}
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              minHeight={40}
            >
              <IconButton
                className={classes.addBtn}
                onClick={addGroup}
              >
                <AddIcon fontSize="small" />
              </IconButton>
              <Box ml={1} className={classes.devicesLabel}>
                Agregar grupo
              </Box>
            </Box>
          )}
        </Grid>
      </Box>

      <Box
        position="sticky"
        bottom="0"
        bgcolor={'#f7f7f9'}
        justifyContent={'center'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
      >
        <Box width={'96%'}>{blueLine}</Box>
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            className={classes.btn}
            onClick={handleSubmit}
            disabled={!thereAreDatasetsInGroup(0) || !mainObj.granularity}
          >
            Consultar
          </Button>
          <Button
            variant="contained"
            onClick={() => setFilterPanel(false)}
            className={classes.btn}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => setShowCleanAllDialog(true)}
            variant="contained"
            className={classes.btn}
            color="secondary"
          >
            Limpiar datos
          </Button>
        </Box>
      </Box>

      <Dialog
        open={showDatasetFilter}
        onClose={handleCloseDatasetFilter}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DatasetFilter
          setShowDatasetFilter={setShowDatasetFilter}
          filterOptions={filterOptions}
          datasetSelected={datasetSelected}
          setMainObj={setMainObj}
          mainObj={mainObj}
          indexGroupselected={indexGroupselected}
          indexDataSetSelected={indexDataSetSelected}
          setActiveStepMainFilter={setActiveStep}
          objectCatalog={objectCatalog}
          statusNodes={statusNodes}
        />
      </Dialog>

      <Dialog
        open={showCleanAllDialog}
        onClose={() => setShowCleanAllDialog(false)}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <Box>
          <DialogTitle id="form-dialog-title">{`¿Está seguro que desea limpiar el filtro?`}</DialogTitle>
          <DialogContent>
            En caso de confirmar, se procederá a eliminar todos los cambios
            realizados en el filtro.
            <Box display={'flex'} justifyContent={'center'}>
              <Button
                variant="contained"
                color="primary"
                className={classes.btn}
                onClick={handleCleanFilter}
              >
                Aceptar
              </Button>
              <Button
                variant="contained"
                onClick={() => setShowCleanAllDialog(false)}
                className={classes.btn}
              >
                Cancelar
              </Button>
            </Box>
          </DialogContent>
        </Box>
      </Dialog>

      <Dialog
        open={showPreview}
        onClose={() => setShowPreview(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle>Históricos (avanzado) - Instrucciones de uso</DialogTitle>
        {blueLine}
        <DialogContent>
          En esta sección podrá generar un gráfico de barras altamente
          personalizable. Las variables seleccionadas podrán presentarse en
          forma de barras apiladas y/o columnas independientes. Cada una de las
          barras apiladas se denomina dataset: un dataset está conformado por la
          elección de un nodo, franja horaria, color personalizado (por defecto
          se utiliza el color propio del nodo seleccionado) y una franja horaria
          (opcional). Cada conjunto de datasets conforma un grupo (que se
          visualiza como una columna). Se permite un máximo de hasta 3 grupos de
          datasets por gráfico.
          <Box display={'flex'} justifyContent={'center'} p={5}>
            <img src="/images/historical_advanced_preview.webp" alt="logo" />
          </Box>
          {blueLine}
          <Box display={'flex'} justifyContent={'center'}>
            <Button
              variant="contained"
              color="primary"
              className={classes.btn}
              onClick={() => setShowPreview(false)}
            >
              Aceptar
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
